import { ViewStream } from 'spyne';
import { AppContainerTraits } from 'traits/app/app-container-traits.js';

export class AppContainer extends ViewStream {
  constructor(props = {}) {
    props.tagName = 'main';
    props.id = 'app';
    props.channels = ['CHANNEL_LOCAL_STORAGE', 'CHANNEL_FULLSCREEN'];
    props.traits = [AppContainerTraits];
    props.dataset = {};
    props.dataset.theme = 'dark';
    props.dataset.fullscreen = 'false';

    super(props);
  }

  addActionListeners() {
    return [
      [
        'CHANNEL_LOCAL_STORAGE_APP_SETTINGS_INITIALIZED_EVENT',
        'app$OnLocalStorageEvent',
      ],
      ['CHANNEL_FULLSCREEN_CHANGE_EVENT', 'app$OnFullscreenChange'],
    ];
  }

  onRendered() {
    this.app$OnAppViewRendered();
  }
}
